module.exports = __webpack_public_path__ + "img/back-arrow-blue.0c80f239.svg";